(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const links = document.querySelectorAll('.js-footer-link');
  links.forEach((link) => {
    link.addEventListener('click', toggleItem, false);
  });
  function toggleItem() {
    if(this.classList.contains('footer-link-active')===false){
      links.forEach((link) => {
        link.classList.remove('footer-link-active');
      });
    }
    this.classList.toggle('footer-link-active');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !window.DesignMode) return;
  try {
    
// const video = document.querySelector(".shopify-section--video-with-text")

// const callback = (entries, observer) => {
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.querySelector(".video-wrapper__play-button").click();
//     }
//   })
// }
// const options = {}
// const myObserver = new IntersectionObserver(callback, options)
// myObserver.observe(video)

  } catch(e) { console.error(e); }
})();
})();
